module.exports = __webpack_public_path__ + "static/media/google_logo.ce11b987.svg";